import {
  MaterialReactTable,
  type MRT_ColumnDef,
  MRT_GlobalFilterTextField,
  useMaterialReactTable,
} from 'material-react-table';
import { Box, Button, FormControl, lighten, MenuItem, Select, Stack } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

type StudentData = {
  student: {
    id: string;
    nome: string;
  };
  total_payments: number;
  total_payments_expiring: number;
  total_payments_expired: number;
  medium_days_expire: number;
  total_paid_time: number;
  total_paid_after: number;
  financial_score: number;
  total_discount: number;
};

const columns: Array<MRT_ColumnDef<StudentData>> = [
  {
    accessorKey: 'student_name',
    header: 'Aluno',
    maxSize: 100,
    sortDescFirst: true,
    enableMultiSort: true,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '5px' }}>{renderedCellValue}</div>
    ),
  },
  {
    accessorKey: 'score_frequency',
    header: 'Score Frequencia',
    maxSize: 100,
    Cell: ({ renderedCellValue }) => (
      <Box
        sx={{
          backgroundColor: '#CEFACE',

          height: '60px',
          width: '60%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {renderedCellValue}
      </Box>
    ),
  },
  {
    accessorKey: 'average_absence_index',
    header: 'Indice total de faltas',
    minSize: 100,
    maxSize: 120,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '20px' }}>{renderedCellValue}%</div>
    ),
  },
  {
    accessorKey: 'discipline_with_most_absence',
    header: 'Disciplina com maior número de faltas',
    minSize: 100,
    maxSize: 150,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '20px' }}>{renderedCellValue}</div>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    maxSize: 100,
    Cell: ({renderedCellValue}) => (
          <Select
          sx={{ borderRadius: '32px',
            width: '90px',
            height: '24px',
            background: 'rgba(239, 239, 239, 1)',
            color: 'rgba(68, 68, 68, 1)',
            fontSize: '12px', padding: '0' 
          }}
          disabled={true}
          value={renderedCellValue ? 10 : 20}  displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
            <MenuItem defaultChecked={true} value={10}>
              {' '}
              <div
                style={{
                  background: 'rgba(15, 219, 98, 1)',
                  borderRadius: '50%',
                  width: '10px',
                  height: '10px',
                  display: 'inline-block',
                  marginRight: '3px',
                }}
              ></div>{' '}
              Ativo
            </MenuItem>
            <MenuItem value={20}>
              {' '}
              <div
                style={{
                  background: '#E04A4C',
                  borderRadius: '50%',
                  width: '10px',
                  height: '10px',
                  display: 'inline-block',
                  marginRight: '3px',
                }}
              ></div>{' '}
              Inativo
            </MenuItem>
          </Select>
      ),
  },
];

type TableHeaderCustomProps = {
  data: StudentData[];
  toBack: string;
};

const TableHeaderCustomTermometroFrequencia = ({ data, toBack }: TableHeaderCustomProps) => {
  const navigate = useNavigate();
  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableRowActions: true,
    enableRowSelection: false,
    enableBottomToolbar: false,
    localization: {
      search: 'Pesquisar por nome do aluno',
      actions: 'Ações',

    },
    initialState: {
      showGlobalFilter: true,
    },
    paginationDisplayMode: 'default',
    enablePagination: false,
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      variant: 'outlined',
      size: 'small',
      fullWidth: true,          
      placeholder: 'Pesquisar por nome…',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActions: ({ row }) => {
      // @ts-ignore
      const studentId = row.original?.student_id;
      // @ts-ignore
      const studentName = row.original?.student_name;

      return (
        <Stack alignItems={'center'}>
          <RemoveRedEye
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => navigate('/termometro-historico-frequencia', {
              state: {
                id: studentId,
                name: studentName,
              },
            })}
          />
        </Stack>
      );
    },
    muiTableHeadCellProps: () => ({
      sx: {
        backgroundColor: 'rgb(247, 247, 247)',
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: () => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
        paddingLeft: '12px',
        padding: '0'
      },
    }),
    renderTopToolbar: ({ table }) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        {/* LEFT‑aligned, full width filter */}
        <Box flexGrow={6} mr={2}>
          <MRT_GlobalFilterTextField
            table={table}
            //@ts-ignore
            textFieldProps={{
              placeholder: 'Pesquisar por nome do aluno…',
              variant: 'outlined',
              size: 'small',
              fullWidth: true,
            }}
          />
        </Box>

        {/* if you have any right‑side buttons, put them here */}
        {/* <Button onClick={…}>My Action</Button> */}
      </Box>
    )
  });

  return (
    <>
      <MaterialReactTable table={tableBasic} />
    </>
  );
};

export default TableHeaderCustomTermometroFrequencia;
